/**
 * =============================================================================
 * stockist-locator.js 
 * =============================================================================
 * 
 * =============================================================================
 */

var StockistLocator = {
  data: {
    selectors: {
      map: "mp-map",
      accordion_item_template: "#mp-template-tile-accordion-item",
      grid_item_template: "#mp-template-tile-grid-item",
      accordion_container: ".mp-accordion",
      grid_container: "#mp-stockists-grid",
      search_form: "#mp-stockist-search",
      reset_button: "#mp-stockist-reset",
      stockist_entry: ".mp-stockist-entry"
    },

    stockists: [],
    map: null,
    markers: [],
    initialBounds: null,
    ready: false,
    firstTime: true
  },

  templates: {
    accordion_item: null,
    grid_item: null
  },

  endpoint: null,

  // geocode_endpoint: "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDO6y6DH1VKxCSshaTs-SRR7VPHHuOUvzQ&address=",
  geocode_endpoint: "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDO6y6DH1VKxCSshaTs-SRR7VPHHuOUvzQ&address=",

  onReady: function() {
    var that = this;

    // Only on stockist page...
    if(MP.Utilities.isStockistLocatorPage()){
      // Compile Lodash template
      this.templates.accordion_item = _.template($(this.data.selectors.accordion_item_template).text());

      // Prevent search form default event
      $(this.data.selectors.search_form).on('submit', function(e) { e.preventDefault(); });

      // Reset the stockist locator when 'Reset' button clicked - show all, fit map to original bounds
      $(this.data.selectors.reset_button).on('click', function(e) { 
        e.preventDefault();
        $('.mp-accordion').addClass('d-none');
        $(that.data.map.fitBounds(that.data.initialBounds));
        $('input', that.data.selectors.search_form).val('');
        $(that.data.selectors.stockist_entry).removeClass('d-none');
        $(this).addClass('d-none');
      });

      // Try to get current location,but need maps to be loaded
      if(navigator.geolocation) {
        var waitForMapReadyInterval = setInterval(function() {
          if(that.data.ready) {
            clearInterval(waitForMapReadyInterval);
            navigator.geolocation.getCurrentPosition(that.onGetCurrentPosition.bind(that));
          }
        }, 4000);
      }
    } else if(MP.Utilities.isAllStockistsPage()) {
      this.templates.grid_item = _.template($(this.data.selectors.grid_item_template).text());
    }
  },

  onGetCurrentPosition: function(position) {
    var that = this;
    var positionFromBrowser = {lat: position.coords.latitude, lng: position.coords.longitude};

    // Calculate distance from position to marker lat lng using Haversine formula
    this.data.markers.forEach(function(marker) {
      marker.distance = that.getDistanceFromLatLonInKm(positionFromBrowser.lat, positionFromBrowser.lng, marker.position.lat(), marker.position.lng())
    });

    // Get the 10 closest markers
    var tenClosestMarkers = this.getNClosestStockistsBounds(positionFromBrowser, 10);
    if(tenClosestMarkers[0].distance > 50){
      this.showOutOfBounds();
    } else {
      this.hideOutOfBounds();
      var newBounds = new google.maps.LatLngBounds();
      tenClosestMarkers.forEach(function(marker) {
        newBounds.extend(marker.position);
      });

      this.data.map.fitBounds(newBounds, 0);
      this.onMapBoundsChange.bind(this);
    }
  },

  showOutOfBounds: function() {
    $('#mp-stockists-out-of-bounds').removeClass('d-none');
    $(this.data.selectors.reset_button)[0].click();
  },

  hideOutOfBounds: function() {
    $('#mp-stockists-out-of-bounds').addClass('d-none');
  },

  // Fetch stockists from JSON file provided from section settings
  getStockists: function(endpoint) {
    this.endpoint = endpoint;
    $.get(this.endpoint, this.onFetchedStockists.bind(this));
  },

  // Setup the google map
  initMap: function() {
    var that = this;
    this.data.map = new google.maps.Map(document.getElementById(this.data.selectors.map), {
      center: {lat: 56.4907, lng: -4.2026},
      zoom: 7
    });

    $(this.data.selectors.search_form).on('submit', function(e) {      
      var searchString = $('input', this).val();
      if(searchString == ""){
        return;
      }

      searchString = encodeURIComponent(searchString);
      var requestUrl = `https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDO6y6DH1VKxCSshaTs-SRR7VPHHuOUvzQ&address=${searchString}`;

      $.get(requestUrl, that.onGeocode.bind(that));
    }); 

    // Add stockist markers when they arrive
    var waitForStockistsInterval = setInterval(function() {
      if(that.data.stockists.length > 0) {
        clearInterval(waitForStockistsInterval);

        that.data.initialBounds = new google.maps.LatLngBounds();

        var infowindow = new google.maps.InfoWindow();

        that.data.stockists.forEach(function(item, index) {

          // Create an infowindow
          var contentString = '<div class="mp-map-infowindow"><h4>' + item.name + '</h4><p>' + item.address + ' ' + item.post_code + '</p></div>';


          // Create a marker
          var position = { lat: parseFloat(item.lat), lng: parseFloat(item.lng) };
          var marker = new google.maps.Marker({
            position: position,
            title: item.name,
            icon: "https://cdn.shopify.com/s/files/1/0029/6619/2195/files/map-marker.png?v=1591357501",
            index: index
          });

          // Assign the infowindow to the marker, show on click
          marker.addListener('click', function() {
            infowindow.setContent(contentString);
            infowindow.open(that.data.map, marker);
          });

          // Store a reference to our marker
          that.data.markers.push(marker)

          that.data.initialBounds.extend(position);
        });

        var clusterOptions = {
          styles: [
            {
              url: "https://cdn.shopify.com/s/files/1/0029/6619/2195/files/m1.png",
              width: 57,
              height: 57,
              anchorText: [-1,1],
              fontFamily: "Georgia,Times,Times New Roman,serif",
              textSize: 15,
              fontWeight: "normal"
            }
          ]
        };

        var markerCluster = new MarkerClusterer(that.data.map, that.data.markers, clusterOptions);
        that.data.map.fitBounds(that.data.initialBounds, 0);
        that.data.ready = true;

        that.data.map.addListener('idle', function() {
          that.onMapBoundsChange();
        });

      }
    }, 200);

  },

  // Handle a geocode response
  onGeocode: function(response) {
    if(response.status !== "OK") {
      alert("Something went wrong trying to find that location");
      return;
    }

    var that = this;
    var position = response.results[0].geometry.location;

    // Get the 10 closest markers
    var tenClosestMarkers = this.getNClosestStockistsBounds(position, 10);
    if(tenClosestMarkers[0].distance > 50){
      this.showOutOfBounds();
    } else {
      this.hideOutOfBounds();
      var newBounds = new google.maps.LatLngBounds();
      tenClosestMarkers.forEach(function(marker) {
        newBounds.extend(marker.position);
      });

      this.data.map.fitBounds(newBounds, 0);
      this.onMapBoundsChange.bind(this);
    }
  },

  getNClosestStockistsBounds: function(position, n) {
    var that = this;

    // Calculate distance from position to marker lat lng using Haversine formula
    this.data.markers.forEach(function(marker) {
      marker.distance = that.getDistanceFromLatLonInKm(position.lat, position.lng, marker.position.lat(), marker.position.lng())
    });

    return this.data.markers.sort(function(a, b) {
      return parseFloat(a.distance) - parseFloat(b.distance);
    }).slice(0, n);
  },

  getDistanceFromLatLonInKm: function(lat1,lon1,lat2,lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2-lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2-lon1); 
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon/2) * Math.sin(dLon/2)
      ; 
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
    var d = R * c; // Distance in km
    return d;
  },

  deg2rad: function(deg) {
    return deg * (Math.PI/180)
  },

  // Update the visible stockists when the map changes
  onMapBoundsChange: function() {
    var visibleMarkers = 0;
    var that = this;

    // Has the page just loaded? If so, don't show the big list
    if(!this.data.firstTime){
      $('.mp-accordion').removeClass('d-none');
    } else {
      this.data.firstTime = false;
    }
    
    // Update the accordion by showing / hiding drawers by whether their marker
    // is in bounds
    this.data.markers.forEach(function(item, index) {
      if(that.data.map.getBounds().contains(item.getPosition())){
        visibleMarkers += 1;
        $("#mp-stockist-" + item.index).removeClass("d-none");
      } else {
        $("#mp-stockist-" + item.index).addClass("d-none");
      }
    });

    if(visibleMarkers > 0) {

      // Attach distance to stockist entries - just for debug
      $(".mp-stockist-entry").each(function(index, element) {
        var distance = that.data.markers.find(function(item) {
          return item.index == parseInt($(element).attr('data-mp-index'));
        }).distance;
        $(element).attr('data-mp-distance', distance);
        $('.mp-stockist-distance', element).text((parseFloat(distance).toFixed(1)) + "km");
      });

      // Order the stockist entry accordion drawers by distance from center
      $(".mp-stockist-entry").sort(function(a,b) { 
        var aMarker = that.data.markers.find(function(item) {
          return item.index == parseInt($(a).attr('data-mp-index'));
        });
        var bMarker = that.data.markers.find(function(item) {
          return item.index == parseInt($(b).attr('data-mp-index'));
        });
        return aMarker.distance - bMarker.distance;
      }).appendTo('.mp-accordion');

      // Update messaging
      var message = "Showing " + visibleMarkers + " locations(s)";
      if(visibleMarkers === this.data.markers.length) {
        $('.mp-accordion').addClass('d-none');
        message = "Use the search bar to find locations near you. or browse the map.";
      }
      $('#mp-stockist-current-message').html(message);
    } else {
      $('#mp-stockist-current-message').html("No locations found");
    }

    if(visibleMarkers !== this.data.markers.length){
      $(this.data.selectors.reset_button).removeClass('d-none');
    }
  },

  // Compile Lodash template with stockist info from JSON and setup accordion
  onFetchedStockists: function(response) {
    var that = this;
    this.data.stockists = response.stockists.sort(function(a, b) {
      if(a.name.trim() < b.name.trim()){
        return -1;
      }
      if(a.name.trim() > b.name.trim()){
        return 1;
      }
      return 0;
    });
    this.data.stockists.forEach(function(item, index) {
      var templateData = _.assign({ 
        name: "",
        address: "",
        address_2: "",
        address_3: "",
        city: "",
        county: "",
        country: "",
        post_code: "",
        phone: "",
        lat: "",
        lng: "",
        distance: "XX",
        id: index
      }, item)

      if(MP.Utilities.isStockistLocatorPage()) {
        var html = that.templates.accordion_item(templateData);
        $(that.data.selectors.accordion_container).append(html);
        $('.mp-marker-icon', '#mp-stockist-'+ index).on('click', function(e) {
          that.zoomToMarker(index);
        });
      } else if(MP.Utilities.isAllStockistsPage()) {
        var html = that.templates.grid_item(templateData);
        $(that.data.selectors.grid_container).append(html);
      }
    });
  },

  zoomToMarker: function(index) {
    var position = this.data.markers[index].position;
    var bounds = new google.maps.LatLngBounds({ lat: position.lat() - 0.1, lng: position.lng() - 0.1 }, { lat: position.lat() + 0.1, lng: position.lng() + 0.1 });
    this.data.map.fitBounds(bounds, 0);
    google.maps.event.trigger(this.data.markers[index], 'click');
  }
};

export default StockistLocator